export const selectorToRecurlyFieldMap = {
    [`first_name`]: `first_name`,
    [`last_name`]: `last_name`,
    [`email`]: `email`,
    [`country`]: `address.country`,
    [`region`]: `address.region`,
    [`city`]: `address.city`,
    [`postal_code`]: `address.postal_code`,
    [`street1`]: `address.street1`,
    [`street2`]: `address.street2`,
    [`phone`]: `address.phone`,
};
